import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  Signal,
  ViewChild,
  effect,
  inject,
} from '@angular/core';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';
import dayjs from 'dayjs';
import {
  AssessmentChartDataRow,
  AssessmentChartDataSets,
  AssessmentType,
  SubTestChartDataSet,
} from '../../services/model';
import { BarChartBaseComponent } from '../bar-chart-base/bar-chart-base.component';
import { getMinMaxDate } from '../../services/assessmentsHistory.functions';

@Component({
  selector: 'app-single-bar-chart',
  standalone: true,
  imports: [],
  template: '<canvas style="width:100%" #canvas [id]="chartId">{{ chart }}</canvas>', // (mouseout)="mouseOut($event)"
})
export class SingleBarChartComponent extends BarChartBaseComponent implements OnInit {
  @Input() data!: Array<AssessmentChartDataRow> | undefined;
  @Input() dataFull!: Signal<AssessmentChartDataSets | undefined>;
  @Input() chartId!: string;
  @Input() label!: string;
  @Input() reverse: boolean = false;
  @Input() type!: 'bar' | 'line';
  @ViewChild('canvas', { read: ElementRef, static: true }) canvas!: ElementRef<any>;

  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  private maxY = 19 * 3; // maximal mögliche Punktzahl ist bei 19 Fragen und 3 Punkten je Frage

  constructor() {
    super();
    effect(() => {
      this.dataFull();
      if (this.chart) {
        this.createChart();
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.createChart();
      this.cdr.detectChanges();
    }, 100);
  }

  createChart() {
    // jür jedes Datum eine Row
    const dataRows: Array<AssessmentChartDataRow> = this.data ?? [];

    const datasetsObject: AssessmentChartDataSets = this.dataFull() ?? {};
    const { minDate, maxDate, labelDataFull } = getMinMaxDate(datasetsObject);

    const data = dataRows.map(row => {
      let unitLabel = '';
      if (this.chartId === 'bbs') {
        unitLabel = 'Punkte';
      }
      const dataset: SubTestChartDataSet = row.subDataSets[0];
      return {
        x: new Date(new Date(row.dateIso).toDateString()),
        data: dataset.score,
        score: row.score,
        sum: dataset.sum,
        tooltipLabel: ` ${row.score} %  (${dataset.sum} ${unitLabel}) `,
        documentId: row.documentId,
        assessmentType: row.type,
      };
    });

    const datasets = [
      {
        label: this.label,
        data: data,
        minBarLength: 2,
        parsing: {
          yAxisKey: 'data',
        },
        maxBarThickness: 30,
      },
    ];

    if (this.chart) {
      this.chart.data = { labels: labelDataFull, datasets: datasets };
      this.chart.options.scales.x.min = minDate;
      this.chart.options.scales.x.max = maxDate;
      this.chart.update();
    } else {
      this.chart = new Chart(
        this.canvas.nativeElement,
        this.getChartConfig(datasets, minDate, maxDate, labelDataFull, this.reverse, 100)
      );
    }
  }
}
